export enum ErrorType {
    Bug = "bug",
    ServerServiceError = "ServerServiceError",
    Unauthenticated = "Unauthenticated",
    Unauthorized = "Unauthorized"
}
